<template>
    <div id="dashboard" class="page-home-dashboard page-main">
        <div class="page-main__content grid">
            <div class="page-home-dashboard__content col-12 col-md-8 col-lg-9">
                <div class="page-home-dashboard__banner">
                    <h2 class="page-home-dashboard__banner-title">
                        My Dashboard
                        <span v-if="user && user.name">
                            Welcome back, {{ user.name }}
                        </span>
                    </h2>
                    <slot name="actions"></slot>
                </div>
                <home-dashboard-client-list></home-dashboard-client-list>
            </div>
            <home-dashboard-sidebar class="col-12 col-md-4 col-lg-3"></home-dashboard-sidebar>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import store from '../store'
import HomeDashboardClientList from './HomeDashboardClientList'
import HomeDashboardSidebar from './HomeDashboardSidebar'

export default {
    store,
    components: {
        HomeDashboardClientList,
        HomeDashboardSidebar
    },
    props: {
        user: {
            type: Object, 
            default: null
        },
        clients: {
            type: Array,
            default: () => []
        },
        favorites: {
            type: Array,
            default: () => []
        },
        recentlyViewed: {
            type: Array,
            default: () => []
        }
    },
    created () {
        this.$store.dispatch('initialize', {
            user: this.user,
            clients: this.clients,
            favorites: this.favorites,
            recentlyViewed: this.recentlyViewed
        })
    }
}
</script>
